import React from 'react'
import PropTypes from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'

class CustomRadioBoxes extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedOption: props.selectedValue,
    }

    this.handleOptionChange = this.handleOptionChange.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedOption !== this.props.selectedOption) {
      this.setState({ selectedOption: this.props.selectedOption })
    }
  }

  handleOptionChange(e) {
    this.setState({ selectedOption: e.target.value })

    this.props.onChange(e.target.value)
  }

  render() {
    return (
      <div className="btn-radio-group">
        {this.props.options.map((option) => (
          <label className="btn-radio" key={option.value}>
            <input
              type="radio"
              value={option.value}
              className="is-hidden"
              name={this.props.name}
              onChange={this.handleOptionChange}
              checked={this.state.selectedOption === option.value}
            />
            <span
              className={`btn ${this.state.selectedOption === option.value ? `btn-${this.props.color}` : 'btn-outline-default'}`}
            >
              {option.icon && <Icon type={option.icon} /> }
              {option.label}
            </span>
          </label>
        ))}
      </div>
    )
  }
}

CustomRadioBoxes.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    icon: PropTypes.array,
  })).isRequired,
  name: PropTypes.string,
  color: PropTypes.string,
  selectedValue: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}

CustomRadioBoxes.defaultProps = {
  options: {
    icon: null,
  },
  name: '',
  color: 'dark',
}

export default CustomRadioBoxes
